import { availableActions } from "../Actions";
import { CommunitySegmentFilterRulesView } from "./CommunitySegmentFilterRulesView";
import type { Log } from "./HistoryAction";

const actionHistoryViewMap = availableActions.reduce((acc, action) => {
  acc.set(action.value, action.historyDetailViewComponent);
  return acc;
}, new Map());

interface HistoryActionMessageProps {
  log: Log;
  status: string;
}

export const HistoryActionMessage = ({
  log,
  status,
}: HistoryActionMessageProps) => {
  const { action } = log.message;
  const { body = {}, url = "" } = log.message.request_details || {};

  const {
    api_params: apiParams = {},
    community_segment_id: communitySegmentId,
  } = action || {};
  const HistoryDetailViewComponent =
    actionHistoryViewMap.get(action?.action_type) || (() => null);

  if (action?.action_type === "time_delay") {
    return (
      <HistoryDetailViewComponent
        body={body}
        url={url}
        apiParams={apiParams}
        log={log}
        status={status}
      />
    );
  }

  return (
    <div className="flex flex-col gap-2">
      {communitySegmentId && (
        <CommunitySegmentFilterRulesView
          communitySegmentId={communitySegmentId}
        />
      )}
      <HistoryDetailViewComponent
        body={body}
        url={url}
        apiParams={apiParams}
        log={log}
        status={status}
      />
    </div>
  );
};
